import enTranslation from "./en/translation.json";
import deTranslation from "./de/translation.json";
import frTranslation from "./fr/translation.json";
export var supportedLanguages = ["en", "de", "fr"];
export var resources = {
    en: { translation: enTranslation },
    de: { translation: deTranslation },
    fr: { translation: frTranslation },
};
